<template>
  <div class="cpt-game-info">
    <div class="game-image-wrapper">
      <img v-src="game.img" alt="" class="game-image" />
      <div class="award-decoration">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="3"
          height="24"
          viewBox="0 0 3 24"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 4L3 0V24L0 20V4Z"
            fill="#405A8C"
          />
        </svg>
        <div class="text">获奖</div>
      </div>
    </div>
    <div class="game-info-wrapper">
      <div class="game-name">{{ game.name }}</div>
      <!-- <div class="desc-title">黑盒锐评:</div> -->
      <!-- <div class="desc-content">{{ game.desc }}</div> -->
      <div class="detail-btn" v-if="game.appid" @click="goGameDetail">
        查看游戏
      </div>
    </div>
  </div>
</template>

<script>
import { executeProtocol } from '_lib/utils';
export default {
  props: {
    game: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    goGameDetail() {
      if (!this.game.appid) return;
      executeProtocol({
        protocol_type: 'openRouterPath',
        path: 'game/detail',
        params: {
          app_id: this.game.appid,
        },
      });
    },
  },
};
</script>

<style lang="less">
.cpt-game-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  .game-image-wrapper {
    flex-shrink: 0;
    position: relative;
    width: 130px;
    height: 195px;
    border-radius: 3px;
    .award-decoration {
      position: absolute;
      top: 10px;
      left: -3px;
      width: 47px;
      height: 24px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      svg {
        width: 3px;
        height: 24px;
      }
      .text {
        width: 44px;
        height: 24px;
        text-align: center;
        background: #3366ca;
        border-radius: 0 3px 3px 0;
        z-index: 10;
        color: #fff;
        font-family: 'PingFang SC';
        font-size: 12px;
        font-weight: 500;
        line-height: 24px;
      }
    }
    .game-image {
      width: 130px;
      height: 195px;
      border-radius: 3px;
      object-fit: cover;
    }
  }
  .game-info-wrapper {
    height: 195px;
    margin-left: 10px;
    flex: 1;
    width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    .game-name {
      width: 100%;
      flex-shrink: 0;
      color: #fff;
      font-family: 'PingFang SC';
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .desc-title {
      justify-self: flex-end;
      flex-shrink: 0;
      margin-top: 10px;
      color: #3366ca;
      font-family: 'PingFang SC';
      font-size: 12px;
      font-weight: 500;
      line-height: 20px;
    }
    .desc-content {
      color: #64696e;
      font-family: 'PingFang SC';
      font-size: 12px;
      font-weight: 300;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }
    .detail-btn {
      // position: absolute;
      // left: 0;
      // bottom: 0;
      // flex-shrink: 0;
      // justify-self: flex-end;
      margin-top: 12px;
      width: 81px;
      height: 32px;
      border-radius: 3px;
      background: #3366ca;
      color: #fff;
      font-family: 'PingFang SC';
      font-size: 13px;
      font-weight: 500;
      line-height: 32px;
      text-align: center;
    }
  }
}
</style>
